import { useEffect } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { getClients } from "../../services/services";
import { useState } from "react";

function ViewClients() {

	const [mstClients, setMstClients] = useState([]);

	useEffect(() => {
		getClients((response) => {
			// console.log(response.data)
			setMstClients(response.data)
		})
	}, [])

	return(
		<Row>
			<Col>
				{mstClients.length > 0 ? 
					<Table>
						<thead>
							<tr>
								<th>ID</th>
								<th>Name</th>
								<th>Address</th>
								<th>Contact Number</th>
								<th>Username</th>
								<th>Regsitered At</th>
							</tr>
						</thead>
						<tbody>
							{mstClients.map(client => {
								return (
									<tr>
										<td>{client.id}</td>
										<td>{client.name}</td>
										<td>{client.address}</td>
										<td>{client.phonenumber}</td>
										<td>{client.username}</td>
										<td>{client.created_time}</td>
									</tr>
								)
							})}
						</tbody>
					</Table>
					:
					<></>
				}
			</Col>
		</Row>
		
	);
};

export default ViewClients;